var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"small":"","text":"","color":"secondary","loading":_vm.loading},on:{"click":function($event){return _vm.load()}}},[_vm._v("List Terminals")]),_c('simple-table',[_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{key:index},[_c('th',[_vm._v("Terminal ID")]),_c('td',[_vm._v(_vm._s(item))])])}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }